<!--
 * @Author: Ashley.Liu
 * @Date: 2022-08-08 20:16:14
 * @LastEditTime: 2023-02-07 14:20:56
 * @Description: desc
-->
<template>
  <div class="search-help-layout" :style="isPined ? 'width: 28vw;' : ''">
    <router-link
      to=""
      @click.native="showHelpContent = true"
      class="search-help-layout__enter"
      >Help</router-link
    >
    <HelpContent
      @close="
        showHelpContent = false
        isPined = false
      "
      v-if="isPined && showHelpContent"
      :is-pined="isPined"
    ></HelpContent>
    <zm-drawer
      v-if="!isPined"
      :visible.sync="showHelpContent"
      outer-clickable
      custom-class="search-help-drawer"
      direction="rtl"
      :with-header="false"
      style="width: 28vw"
    >
      <HelpContent
        @close="showHelpContent = false"
        @pin="isPined = true"
      ></HelpContent>
    </zm-drawer>
  </div>
</template>

<script>
import HelpContent from '../helpContent.vue'
export default {
  name: 'HelpLayout',
  components: {
    HelpContent
  },
  data() {
    return {
      showHelpContent: false,
      isPined: false
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.search-help-layout {
  position: relative;
  &__enter {
    position: absolute;
    left: -52px;
    top: 12px;
    font-size: 16px;
  }

  .zm-drawer__container {
    top: 51px;
  }
  .zm-drawer__wrapper {
    z-index: 1003 !important;
  }
  .search-help-drawer {
    border-left: 1px solid #dfe3e8;
    box-shadow: none !important; // drawer title dom has style
  }
}
</style>
